<!--
 * @Description: 全屏按钮
 * @Author: ZY
 * @Date: 2020-12-23 18:11:46
 * @LastEditors: SCY
 * @LastEditTime: 2021-04-02 14:31:08
-->

<template>
  <div :class="right ? 't-right' : ''">
    <el-select
      v-model="value"
      class="select-style-2"
      popper-class="select-option-style-2"
      placeholder="请选择"
      @change="changeHandle"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, reactive, toRefs, ref } from 'vue'

export default defineComponent({
  props: {
    right: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'month'
    }
  },
  setup(props,context) {
    const value = ref(0)
    let options:any = []

    if( props.type === 'year' ){
      options = [
        {
          value: 0,
          label: '最近3年',
          timeLevel: '3y'
        },
        {
          value: 1,
          label: '最近5年',
          timeLevel: '5y'
        },
        {
          value: 2,
          label: '最近10年',
          timeLevel: '10y'
        }
      ]
    }else{
      options = [
        {
          value: 0,
          label: '最近1月',
          timeLevel: '1m'
        },
        {
          value: 1,
          label: '最近3月',
          timeLevel: '3m'
        },
        {
          value: 2,
          label: '最近6月',
          timeLevel: '6m'
        },
        {
          value: 3,
          label: '最近1年',
          timeLevel: '1y'
        }
      ]
    }

    const changeHandle = (val:any) => {
      context.emit('change', options[val])
    }
    context.emit('change', options[0])
    return {
      value,
      options,
      changeHandle
    }

    // return {
    //   ...toRefs(state)
    // }
  }
})

</script>
<style lang='scss' scoped>
.t-right{
  text-align: right;
  margin-bottom: 15px;
}
</style>
